import { f as r } from "./directive-helpers-B5UsscjS.js";
import { i as A, t as c } from "./directive-B5s9Ooqi.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const o = (i, s) => {
  var t;
  const e = i._$AN;
  if (e === void 0) return !1;
  for (const n of e) (t = n._$AO) == null || t.call(n, s, !1), o(n, s);
  return !0;
}, _ = (i) => {
  let s, e;
  do {
    if ((s = i._$AM) === void 0) break;
    e = s._$AN, e.delete(i), i = s;
  } while ((e == null ? void 0 : e.size) === 0);
}, $ = (i) => {
  for (let s; s = i._$AM; i = s) {
    let e = s._$AN;
    if (e === void 0) s._$AN = e = /* @__PURE__ */ new Set();
    else if (e.has(i)) break;
    e.add(i), l(s);
  }
};
function d(i) {
  this._$AN !== void 0 ? (_(this), this._$AM = i, $(this)) : this._$AM = i;
}
function f(i, s = !1, e = 0) {
  const t = this._$AH, n = this._$AN;
  if (n !== void 0 && n.size !== 0) if (s) if (Array.isArray(t)) for (let h = e; h < t.length; h++) o(t[h], !1), _(t[h]);
  else t != null && (o(t, !1), _(t));
  else o(this, i);
}
const l = (i) => {
  i.type == c.CHILD && (i._$AP ?? (i._$AP = f), i._$AQ ?? (i._$AQ = d));
};
class C extends A {
  constructor() {
    super(...arguments), this._$AN = void 0;
  }
  _$AT(s, e, t) {
    super._$AT(s, e, t), $(this), this.isConnected = s._$AU;
  }
  _$AO(s, e = !0) {
    var t, n;
    s !== this.isConnected && (this.isConnected = s, s ? (t = this.reconnected) == null || t.call(this) : (n = this.disconnected) == null || n.call(this)), e && (o(this, s), _(this));
  }
  setValue(s) {
    if (r(this._$Ct)) this._$Ct._$AI(s, this);
    else {
      const e = [...this._$Ct._$AH];
      e[this._$Ci] = s, this._$Ct._$AI(e, this, 0);
    }
  }
  disconnected() {
  }
  reconnected() {
  }
}
export {
  C as f
};
//# sourceMappingURL=async-directive-DXZeVyIn.js.map
